/* eslint-disable */
export default {
  dialPlaceholder: '名前または番号を入力',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
